import { render, staticRenderFns } from "./TreeItem.vue?vue&type=template&id=2b2de39d&scoped=true"
import script from "./TreeItem.vue?vue&type=script&lang=js"
export * from "./TreeItem.vue?vue&type=script&lang=js"
import style0 from "@/assets/sass/pages/archive/tree-item.scss?vue&type=style&index=0&id=2b2de39d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2de39d",
  null
  
)

export default component.exports